// extracted by mini-css-extract-plugin
export default {"trip-bar-cell":"TripDistributionBar_trip-bar-cell__eqrzQ","trip-bar-label":"TripDistributionBar_trip-bar-label__noIJG"};